import React, { createContext, useContext } from "react";
import PropTypes from "prop-types";
//Limitless imports
import { useLogging } from "./DevLoggingHook";
// Set the default state values for each context
export const DevLogging = /*#__PURE__*/createContext({});
export const DevLoggingProvider = ({
  children
}) => {
  const hook = useLogging();
  return /*#__PURE__*/React.createElement(DevLogging.Provider, {
    value: hook
  }, children);
};
export const useDevLogging = () => {
  return useContext(DevLogging);
};
DevLoggingProvider.propTypes = {
  children: PropTypes.node.isRequired
};